<template>
  <div>
    <img
      src="https://resource.rcclchina.com.cn/CruiseSearchBanner/FUK-20230901.jpg"
      class="cruise-banner-image"
      ref="cruiseBannerImage"
      :style="cruiseImageStyle"
      v-on:load="resizeCruiseBanner"
    />
    <div class="saleArea">
      <div class="tagbg">您上次浏览的航线</div>
      <div class="big-title">{{ cruiseInfo.tagContent }}</div>
      <div class="txt1 text">
        {{ cruiseInfo.cruiseCNName }}
      </div>
      <div class="txt2 text">
        {{ cruiseInfo.sailDateBegin }} -
        {{ cruiseInfo.sailDateEnd }}&nbsp;&nbsp; |&nbsp;&nbsp;{{
          cruiseInfo.sailDays
        }}天{{ cruiseInfo.sailDays - 1 }}晚&nbsp;&nbsp;|&nbsp;&nbsp;{{
          cruiseInfo.shipCNName
        }}
      </div>
      <div class="line"></div>
      <div class="price">
        <div class="tiny">
          <span>{{ cruiseInfo.isNrp ? "早订特惠价" : "优惠价" }}</span>
          <span
            >￥<i>{{ cruiseInfo.price ? cruiseInfo.price.toFixed(0) : "" }}</i
            >/人起</span
          >
        </div>
        <a :href="banner.url" class="p-btn" @click="gioTrack(banner.url)">立即预订</a>
      </div>
    </div>
  </div>
</template>

<script>
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "HomeCruiseBanner",
  props: {
    banner: {
      type: Object,
    },
		index: {
			type: Number
		}
  },
  data() {
    return {
      cruiseImageStyle: {},
    };
  },
  mounted() {
    this.resizeCruiseBanner();
    window.onresize = () => {
      this.resizeCruiseBanner();
    };
  },
  methods: {
    resizeCruiseBanner() {
      if (this.$refs.cruiseBannerImage && document) {
        const windowWidth =
          document.body.clientWidth >= 1280 ? document.body.clientWidth : 1280;
        const width = windowWidth;
        const height = (width / 1920) * 648;
        const imageWidth = this.$refs.cruiseBannerImage.width;
        const imageHeight = this.$refs.cruiseBannerImage.height;
        var resizeImageWidth = (width * imageHeight) / height;
        var left = -(Math.abs(imageWidth - resizeImageWidth) / 2);
        this.cruiseImageStyle = {
          left: left + "px",
          width: width + "px",
          height: height + "px",
        };
      }
    },
		gioTrack(url) {
			const eventObject = {
				"adsType": "bn",
				"bnOrder": this.index+1,
				"desUrl": url
			}
			gioAdsTracking(eventObject);
		}
  },
  computed: {
    cruiseInfo() {
      return this.banner.cruiseInfo || {};
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
}

.saleArea {
  width: 696px;
  height: 284px;
  position: absolute;
  left: 20%;
  top: 20%;
  background: rgba(0, 0, 0, 0.6);
}

.saleArea .tagbg {
  width: 158px;
  height: 24px;
  position: absolute;
  left: -5px;
  top: 10px;
  background: url("https://resource.rcclchina.com.cn/homePage/linebg.png")
    no-repeat 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
}
.saleArea .big-title {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  margin-left: 30px;
  margin-bottom: 29px;
  position: relative;
  top: 27px;
}
.saleArea .text {
  font-size: 16px;
  color: #fff;
  margin-left: 30px;
  margin-bottom: 10px;
  font-weight: 400;
}
.saleArea .txt1 > span {
  display: inline-block;
  width: 80px;
  height: 22px;
  border-radius: 20px;
  background: #ffa70d;
  font-size: 12px;
  color: #333;
  line-height: 22px;
  margin-left: 2px;
}
.saleArea .txt1 > span img {
  margin-left: 12px;
  margin-right: 3px;
  position: relative;
  top: -1px;
}
.saleArea .txt2 {
  margin-bottom: 15px;
}
.saleArea .line {
  width: 60px;
  height: 1px;
  margin-left: 30px;
  margin-bottom: 16px;
  background: #fbc500;
}
.saleArea .price {
  /* width: 402px; */
  display: block;
  justify-content: space-between;
  margin-left: 30px;
}
.saleArea .price .tiny {
  display: inline-block;
  vertical-align: top;
}
.saleArea .price .tiny span:first-child {
  color: #fff;
  font-size: 16px;
}
.saleArea .price .tiny span:last-child {
  color: #fbc500;
  font-size: 16px;
  display: block;
}
.saleArea .price .tiny span:last-child > i {
  font-style: normal;
  font-size: 30px;
  font-weight: bold;
}
.saleArea .price .p-btn {
  display: block;
  width: 188px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  color: #282b2c;
  background: #fbc500;
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  cursor: pointer;
}
.saleArea .price .p-btn:hover {
  background: #f8de57;
}
</style>

